<mat-toolbar color="accent">
  <h2>Add Patient</h2>
</mat-toolbar>

<mat-dialog-content>
  <pr-edit-patient-form #form (submitted)="addPatient($event)" />
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="form.patientForm.invalid"
      (click)="form.submit()"
    >
      Add Patient
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
